import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RequestUserData } from "../incadea-interfaces/requests/RequestUserData.interface";
import { ResponseUserData } from "../incadea-interfaces/responses/ResponseUserData.interface";
import { incadeaConfig, incadeaEnvironment } from "src/environments/environment";
@Injectable({
    providedIn: 'root',
  })
export class GetTokenService {
    constructor(private http: HttpClient) { }
    public getToken() {
      
      const urlencoded = new URLSearchParams();
      urlencoded.append("client_id", incadeaConfig.clientId);
      urlencoded.append("client_secret", incadeaConfig.clientSecret);
      urlencoded.append("grant_type", "client_credentials");
        // Define el cuerpo de la solicitud POST
      
        // Define el encabezado de la solicitud
        const headers: HttpHeaders = new HttpHeaders().set("Content-Type", "application/x-www-form-urlencoded");
      
        // Realiza la solicitud POST
        
      return  this.http.post<ResponseUserData>(incadeaEnvironment.token, urlencoded, { headers })
      }
    }
  